module.exports = __webpack_public_path__ + "img/site_builder_inst.360e9356.png";